import React, { useEffect, useState } from "react";
import { Card, Table, Row, Col, Button, Divider } from "antd";
import 'antd/dist/antd.css';
import moment from "moment";
import { InfoCircleFilled } from "@ant-design/icons";
import { Empty } from "antd";


export const EmptyTable = () => {

    return (
        <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={<span style={{ fontSize: "14px" }}>Nuk ka të dhëna!</span>}
        />
    );
};



export const ErrorCard = ({ message }) => {

    return (
        <Row gutter={24}>
            <Col span={24}>
                <Row gutter={24}>
                    <Col span={24}>
                        <Divider className="w-100" style={{ marginTop: "0px", marginBottom: "0px" }} />
                    </Col>
                </Row>
                <Row gutter={24} className="mt-5 mb-5">
                    <Col xl={24} lg={24} md={0} sm={0} xs={0}>
                        <Row gutter={24} className="h-100" align="middle">
                            <Col span={24} className="text-center">
                                <InfoCircleFilled style={{ fontSize: "45px", color: "#faad14" }} />
                            </Col>
                            <Col span={24} className="text-center h-100 mt-4">
                                <h4 className="m-0 p-0">{message}</h4>
                            </Col>
                        </Row>
                    </Col>
                    <Col xl={0} lg={0} md={24} sm={24} xs={24}>
                        <Row gutter={24} className="h-100" align="middle">
                            <Col span={24} className="text-center">
                                <InfoCircleFilled style={{ fontSize: "22px", color: "#faad14" }} />
                            </Col>
                            <Col span={24} className="text-center h-100 mt-1">
                                <h6 className="m-0 p-0">{message}</h6>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row gutter={24}>
                    <Col span={24}>
                        <Divider className="w-100" style={{ marginTop: "0px", marginBottom: "0px" }} />
                    </Col>
                </Row>
            </Col>
        </Row>
    );
};



const List = ({ dispatch, items, updateVoter, isLoading, errorMessage, onChoose }) => {
    const [dataSource, setDataSource] = useState(items);


    const tableColumns = [
        {
            title: "#",
            dataIndex: "row_number",
            key: "row_number",
            align: "center",
            width: 60,
            render: (value) => <b>{value}.</b>,
        },
        {
            title: "Emri",
            dataIndex: "name",
            width: 120,
        },
        {
            title: "Mbiemri",
            dataIndex: "surname",
            width: 120,
        },
        {
            title: "Atësia",
            dataIndex: "father_name",
            width: 120,
        },
        {
            title: "Amësia",
            dataIndex: "mother_name",
            width: 120,
        },
        {
            title: "Datëlindja",
            dataIndex: "dob",
            align: "center",
            width: 130,
            render: (_, elm) => (
                moment(elm?.dob).format("DD/MM/YYYY")
            )
        },
        {
            title: "QV",
            dataIndex: "qv_code_full",
            align: "center",
            width: 100,
        },
        {
            title: "Veprime",
            dataIndex: "actions",
            align: "center",
            width: 140,
            render: (_, elm) => (
                <div>

                    {/* {elm?.isSelected === false && ( */}
                    <Button
                        type="primary"
                        size="small"
                        ghost
                        onClick={() => onSelect(elm)}
                    >
                        Zgjidh
                    </Button>
                    {/* )} */}

                    {/* {elm?.isSelected === true && (
                        <Button
                            type="primary"
                            size="small"
                            onClick={() => onSelect(elm)}
                            icon={<CheckOutlined />}
                        >
                            Zgjedhur
                        </Button>
                    )} */}

                </div>
            ),
        },
    ];


    useEffect(() => {
        setDataSource(items);
    }, [items]);


    const updateItems = (items, item) => {
        const updatedItems = items?.map((elm) => {
            if (elm?.id === item?.id) {
                return {
                    ...elm,
                    isSelected: !item?.isSelected,
                };
            }
            return {
                ...elm,
                isSelected: false
            };
        });
        const action = {
            type: "set_items",
            payload: {
                items: updatedItems,
                total: updatedItems?.length,
            },
        };
        dispatch(action);
    };


    const onSelect = (item) => {
        updateItems(items, item);
        if (item?.isSelected === false) {
            updateVoter(item);
        }
        onChoose();
    };


    return (
        <Row gutter={24}>
            <Col span={24}>
                <Card bodyStyle={{ padding: "0px" }}>
                    <div className="table-responsive">
                        <Table
                            size="small"
                            columns={tableColumns}
                            rowKey="row_number"
                            bordered="true"
                            dataSource={dataSource}
                            pagination={{ pageSize: 5 }}
                            loading={isLoading}
                            scroll={{ x: 800 }}
                            showHeader="true"
                            locale={{ emptyText: errorMessage ? <ErrorCard message={errorMessage} /> : <EmptyTable /> }}
                        />
                    </div>
                </Card>
            </Col>
        </Row>
    );
};


export default List;